var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 59,
    viewBox: "0 0 85 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1880",
    "data-name": "Groupe 1880",
    transform: "translate(0.073 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(51 19.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,39V14.012L17,0l7.65,6.306V4.437h3.967V9.575L34,14.012V39Z",
    transform: "translate(-0.073 0.001)",
    fill: "#e6f6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.497 2.994)",
    fill: "#e6f6fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.31504058837891 33.28632354736328 L 0.7500002980232239 33.28632354736328 L 0.7500002980232239 12.20437622070312 L 14.53534030914307 0.9676777124404907 L 28.31504058837891 12.20429420471191 L 28.31504058837891 33.28632354736328 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.53525161743164 1.935340881347656 L 1.5 12.56062889099121 L 1.5 32.53632354736328 L 27.56504058837891 32.53632354736328 L 27.56504058837891 12.56044578552246 L 14.53525161743164 1.935340881347656 M 14.53544044494629 3.814697265625e-06 L 29.06504058837891 11.84812355041504 L 29.06504058837891 34.03632354736328 L 0 34.03632354736328 L 0 11.84812355041504 L 14.53544044494629 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,59V21.2L25.5,0,36.975,9.539V6.713h5.95v7.773L51,21.2V59Z",
    transform: "translate(-0.073 0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(3.735 5.071)",
    fill: "#00a3da",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.72003555297852 50.15515518188477 L 0.7500039339065552 50.15515518188477 L 0.7500039339065552 18.07644653320312 L 21.73928451538086 0.9676777720451355 L 42.72003555297852 18.07636451721191 L 42.72003555297852 50.15515518188477 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.73919486999512 1.935333251953125 L 1.499992370605469 18.43270111083984 L 1.499992370605469 49.40514373779297 L 41.97002410888672 49.40514373779297 L 41.97002410888672 18.43251419067383 L 21.73919486999512 1.935333251953125 M 21.73938369750977 -7.62939453125e-06 L 43.47002410888672 17.72019195556641 L 43.47002410888672 50.90514373779297 L -7.62939453125e-06 50.90514373779297 L -7.62939453125e-06 17.72019195556641 L 21.73938369750977 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleHouse);
export default __webpack_public_path__ + "static/media/double-house.fb428ca3f29f59e556c8d4faf25d6a88.svg";
export { ForwardRef as ReactComponent };